import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  toolbarRoot: {
    paddingRight: theme.spacing(),
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'flex-end',
  },
  title: {
    flex: '0 0 auto',
  },

}))

const SimpleTableHeader = ({
  className,
  title,
  getTitle,
  getActions,
  titleVariant,
  titleClassname,
}) => {
  const classes = useStyles()

  return (
    <Toolbar
      className={ `${classes.toolbarRoot} ${className || ''}` }
    >
      <div className={classes.title}>
        {
          getTitle ? (
            getTitle()
          ) : (
            <Typography className={ titleClassname } variant={ titleVariant || 'h6' }>{ title }</Typography>
          )   
        }
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {
          getActions ? getActions() : null
        }
      </div>
    </Toolbar>
  )
}

export default SimpleTableHeader